import script from "./ChartArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartArea.vue?vue&type=script&setup=true&lang=js"

import "./ChartArea.vue?vue&type=style&index=0&id=24079332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24079332"]])

export default __exports__